import React from 'react'
import '.././PopupCommonStyle.css'
import styles from './Style.module.css'
// import { PillBtn } from '../../Buttons/PillBtn/PillBtn'
// import { BtnClose } from '../../Buttons/BtnClose/BtnClose';
import { BtnSecondary } from '../../Buttons/BtnSecondary';
import { BtnPrimary } from '../../Buttons/BtnPrimary';

export const RemoveGuestPopup = ({ active, onClose, onConfirmRemove }) => {
  return (
    <div className={`${styles.removeGuestPopup} popup ${active ? "show" : ""}`}>
        <div className={`${styles.popHeader} popup-header`}>
        <h2 className="title">Are you sure you want to remove the guest?</h2>
        <h6 className="titleSub">If you remove the guest, it will also remove the selected service.</h6>
        </div>
        {/* <BtnClose
        handleClick={onClose}
        title="Close"
        customClass="popup-exit-btn circled"
        iconColor="#ffffff"
        iconSize={16}
        /> */}

        <div className={`${styles.footer} popup-footer`}>
          <BtnSecondary
            label="Close"
            handleClick={onClose}
            customClass="w-100 no-icon"
          />
          <BtnPrimary
            label="Remove Guest"
            handleClick={onConfirmRemove}
            varient="danger"
            customClass="w-100 no-icon"
          />
        </div>

        {/* <div className={`${styles.footer} popup-footer`}>
          <PillBtn 
          label="Remove Guest"
          variant="smallPill"
          type="Primary"
          customClass="w-100 delete-btn"
          handleClick={onConfirmRemove}
          title="Remove Guest"
          />  
          <PillBtn 
            label="Back"
            variant="smallPill"
            type="Secondary"
            customClass="w-100"
            handleClick={onClose}
            title="Back"
            />
        </div> */}
    </div>
  )
}
